(function () {
  const PRODUCT_TEMPLATE_CLASS = 'Template--product';

  if (!document.body.classList.contains(PRODUCT_TEMPLATE_CLASS)) return;

  const galleryImages = collectGalleryImages();

  if (!galleryImages.length) return;

  const imageData = galleryImages.map((img) => ({
    src: img.currentSrc || img.src,
    alt: img.getAttribute('alt') || '',
  }));

  ensureBootstrapAssets(() => {
    const modal = createModal(imageData);

    const openHandlers = (event, index) => {
      event.preventDefault();
      console.log('[product-modal-gallery] clicked image', { index, src: imageData[index]?.src });
      modal.open(index);
    };

    galleryImages.forEach((img, index) => {
      const wrapper = img.closest('.Product__MediaWrapper') || img.parentElement;
      if (wrapper) {
        let pointerStart = null;
        let pointerMoved = false;
        const MOVE_THRESHOLD = 20;

        const resetPointerPosition = () => {
          pointerStart = null;
        };

        const resetPointerMovement = () => {
          pointerMoved = false;
        };

        const resetAllPointerState = () => {
          resetPointerPosition();
          resetPointerMovement();
        };

        wrapper.addEventListener('pointerdown', (event) => {
          pointerStart = { x: event.clientX, y: event.clientY };
          pointerMoved = false;
        });

        wrapper.addEventListener('pointermove', (event) => {
          if (!pointerStart) return;
          const deltaX = event.clientX - pointerStart.x;
          const deltaY = event.clientY - pointerStart.y;
          if (Math.hypot(deltaX, deltaY) > MOVE_THRESHOLD) {
            pointerMoved = true;
          }
        });

        wrapper.addEventListener('pointerup', () => {
          resetPointerPosition();
          // keep pointerMoved until click handler evaluates it
        });

        wrapper.addEventListener('pointercancel', resetAllPointerState);
        wrapper.addEventListener('pointerleave', resetAllPointerState);

        wrapper.addEventListener('click', (event) => {
          if (pointerMoved) {
            resetAllPointerState();
            return;
          }
          resetAllPointerState();
          openHandlers(event, index);
        });

        wrapper.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            openHandlers(event, index);
          }
        });
      }
    });
  });

  function collectGalleryImages() {
    const selectors = [
      '.Product__MediaWrapper[data-media-type="image"] img',
      '.ProductGallery__Carousel .Carousel__Item img',
    ];

    for (const selector of selectors) {
      const found = Array.from(document.querySelectorAll(selector));
      if (found.length) return found;
    }

    return [];
  }

  function ensureBootstrapAssets(callback) {
    const bootstrapReady = () => window.bootstrap && typeof window.bootstrap.Modal === 'function';

    const onReady = () => {
      if (bootstrapReady()) callback();
    };

    if (!document.querySelector('link[data-product-modal-bootstrap]')) {
      const css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css';
      css.dataset.productModalBootstrap = 'true';
      document.head.appendChild(css);
    }

    if (bootstrapReady()) {
      callback();
      return;
    }

    const existingScript = document.querySelector('script[data-product-modal-bootstrap]');
    if (existingScript) {
      existingScript.addEventListener('load', onReady, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js';
    script.async = true;
    script.dataset.productModalBootstrap = 'true';
    script.addEventListener('load', onReady, { once: true });
    document.body.appendChild(script);
  }

  function createModal(imageList) {
    const hasMultipleImages = imageList.length > 1;
    let currentIndex = 0;
    let isPointerDown = false;
    let pinchZoomActive = false;
    let startX = 0;
    let currentTranslate = 0;
    let pinchStartDistance = 0;
    let currentScale = 1;
    let panX = 0;
    let panY = 0;
    let panStart = null;
    let swipeCloseStartX = null;
    let swipeCloseStartY = null;
    const pointerCache = new Map();




    const modalEl = document.createElement('div');
    modalEl.className = 'modal fade product-modal-gallery-modal';
    modalEl.tabIndex = -1;
    modalEl.setAttribute('aria-hidden', 'true');

    const dialog = document.createElement('div');
    dialog.className = 'modal-dialog modal-dialog-centered modal-xl product-modal-gallery-dialog';

    const content = document.createElement('div');
    content.className = 'modal-content product-modal-gallery-content';

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'ProductModalGallery__close';
    closeBtn.setAttribute('aria-label', 'Close modal');
    closeBtn.innerHTML = '&times;';

    const body = document.createElement('div');
    body.className = 'modal-body product-modal-gallery-body';

    const viewport = document.createElement('div');
    viewport.className = 'ProductModalGallery__viewport';

    const track = document.createElement('div');
    track.className = 'ProductModalGallery__track';

    const pagination = document.createElement('div');
    pagination.className = 'ProductModalGallery__pagination';

    const dots = document.createElement('div');
    dots.className = 'ProductModalGallery__dots';

    const prevBtn = document.createElement('button');
    prevBtn.className = 'ProductModalGallery__nav ProductModalGallery__nav--prev btn btn-dark';
    prevBtn.type = 'button';
    prevBtn.innerHTML = '&#10094;';

    const nextBtn = document.createElement('button');
    nextBtn.className = 'ProductModalGallery__nav ProductModalGallery__nav--next btn btn-dark';
    nextBtn.type = 'button';
    nextBtn.innerHTML = '&#10095;';

    if (!hasMultipleImages) {
      prevBtn.hidden = true;
      nextBtn.hidden = true;
    }

    imageList.forEach(({ src, alt }) => {
      const slide = document.createElement('div');
      slide.className = 'ProductModalGallery__slide';

      const wrapper = document.createElement('div');
      wrapper.className = 'ProductModalGallery__imageWrapper';

      const image = document.createElement('img');
      image.className = 'ProductModalGallery__image';
      image.src = src;
      image.alt = alt;
      image.decoding = 'async';
      image.loading = 'lazy';

      wrapper.appendChild(image);
      slide.appendChild(wrapper);
      track.appendChild(slide);

      attachZoomHandlers(wrapper, image);
    });

    pagination.textContent = paginationLabel(currentIndex, imageList.length);
    renderDots();
    viewport.appendChild(track);

    body.appendChild(viewport);
    body.appendChild(prevBtn);
    body.appendChild(nextBtn);
    body.appendChild(pagination);
    body.appendChild(dots);
    body.appendChild(closeBtn);

    content.appendChild(body);

    dialog.appendChild(content);
    modalEl.appendChild(dialog);
    document.body.appendChild(modalEl);

    const bsModal = new bootstrap.Modal(modalEl, { backdrop: true, focus: true });

    modalEl.addEventListener('hidden.bs.modal', () => {
      resetZoom();
      currentTranslate = 0;
      toggleMenuVisibility(true);
    });

    modalEl.addEventListener('show.bs.modal', () => toggleMenuVisibility(false));

    prevBtn.addEventListener('click', () => moveToSlide(currentIndex - 1));
    nextBtn.addEventListener('click', () => moveToSlide(currentIndex + 1));
    closeBtn.addEventListener('click', () => bsModal.hide());

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', onPointerUp);
    viewport.addEventListener('pointerleave', onPointerUp);

    modalEl.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') moveToSlide(currentIndex - 1);
      if (event.key === 'ArrowRight') moveToSlide(currentIndex + 1);
    });

    function open(index) {
      currentIndex = index;
      updateSlidePosition(true);
      pagination.textContent = paginationLabel(currentIndex, imageList.length);
      updateDots();
      bsModal.show();
    }

    function moveToSlide(targetIndex) {
      const total = imageList.length;
      if (total <= 1) return;
      if (targetIndex < 0) targetIndex = total - 1;
      if (targetIndex >= total) targetIndex = 0;
      currentIndex = targetIndex;
      updateSlidePosition();
      pagination.textContent = paginationLabel(currentIndex, imageList.length);
      updateDots();
      resetZoom();
    }

    function updateSlidePosition(skipAnimation) {
      if (skipAnimation) track.style.transition = 'none';
      requestAnimationFrame(() => {
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
        if (skipAnimation) {
          void track.offsetWidth;
          track.style.transition = '';
        }
      });
    }

    function paginationLabel(index, total) {
      return `${index + 1} / ${total}`;
    }

    function renderDots() {
      dots.innerHTML = '';
      imageList.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ProductModalGallery__dot';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => moveToSlide(index));
        dots.appendChild(dot);
      });
      updateDots();
    }

    function updateDots() {
      const dotButtons = dots.querySelectorAll('.ProductModalGallery__dot');
      dotButtons.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentIndex);
      });
    }

    function onPointerDown(event) {
      if (event.pointerType === 'touch') {
        pointerCache.set(event.pointerId, event);
        pinchZoomActive = pinchZoomActive || pointerCache.size >= 2;
      }
      isPointerDown = true;
      startX = event.clientX;
      currentTranslate = 0;
      if (!pinchZoomActive && currentScale > 1) {
        panStart = { x: event.clientX, y: event.clientY };
      }
      if (event.pointerType === 'touch') {
        swipeCloseStartX = event.clientX;
        swipeCloseStartY = event.clientY;
      }
    }

    function onPointerMove(event) {
      if (pointerCache.has(event.pointerId)) {
        pointerCache.set(event.pointerId, event);
        if (pointerCache.size === 2) {
          pinchZoomActive = true;
          const [p1, p2] = Array.from(pointerCache.values());
          const distance = Math.hypot(p2.clientX - p1.clientX, p2.clientY - p1.clientY);
          if (!pinchStartDistance) pinchStartDistance = distance;
          const scale = Math.min(Math.max(distance / pinchStartDistance, 1), 3.5);
          applyScale(scale);
          return;
        }
      }

      if (!isPointerDown || pointerCache.size > 1) return;

      if (currentScale > 1) {
        if (!panStart) {
          panStart = { x: event.clientX, y: event.clientY };
        }
        const deltaX = event.clientX - panStart.x;
        const deltaY = event.clientY - panStart.y;
        panStart = { x: event.clientX, y: event.clientY };
        panX += deltaX;
        panY += deltaY;
        clampPan();
        updateImageTransform();
        resetSwipeCloseTracking();
        return;
      }

      const deltaX = event.clientX - startX;
      currentTranslate = deltaX;
    }

    function onPointerUp(event) {
      const wasPinching = pinchZoomActive || pointerCache.size >= 2;
      if (pointerCache.has(event.pointerId)) {
        pointerCache.delete(event.pointerId);
        if (pointerCache.size < 2) {
          pinchStartDistance = 0;
          if (pointerCache.size === 0) {
            pinchZoomActive = false;
          }
        }
      }

      if (!isPointerDown) return;

      isPointerDown = false;
      panStart = null;
      if (wasPinching) {
        resetSwipeCloseTracking();
        return;
      }
      if (currentScale > 1) {
        resetSwipeCloseTracking();
        return;
      }
      if (event.pointerType === 'touch' && shouldCloseModalOnSwipe(event)) {
        bsModal.hide();
        resetSwipeCloseTracking();
        return;
      }

      if (Math.abs(currentTranslate) > 50 && currentScale === 1) {
        if (currentTranslate < 0) {
          moveToSlide(currentIndex + 1);
        } else {
          moveToSlide(currentIndex - 1);
        }
      }
      currentTranslate = 0;
      resetSwipeCloseTracking();
    }

    function shouldCloseModalOnSwipe(event) {
      if (swipeCloseStartY === null || swipeCloseStartX === null) return false;
      const deltaY = event.clientY - swipeCloseStartY;
      const deltaX = event.clientX - swipeCloseStartX;
      const CLOSE_THRESHOLD = 80;
      const isUpwardSwipe = deltaY < -CLOSE_THRESHOLD;
      const isDownwardSwipe = deltaY > CLOSE_THRESHOLD;
      const isVerticalDominant = Math.abs(deltaY) > Math.abs(deltaX);
      return (isUpwardSwipe || isDownwardSwipe) && isVerticalDominant && window.matchMedia('(pointer: coarse)').matches;
    }

    function resetSwipeCloseTracking() {
      swipeCloseStartX = null;
      swipeCloseStartY = null;
    }

    function applyScale(scale) {
      currentScale = scale;
      clampPan();
      updateImageTransform();
    }

    function resetZoom() {
      currentScale = 1;
      pinchStartDistance = 0;
      panX = 0;
      panY = 0;
      panStart = null;
      pointerCache.clear();
      track.querySelectorAll('.ProductModalGallery__image').forEach((image) => {
        image.style.transform = 'translate(0, 0) scale(1)';
      });
    }

    function clampPan() {
      const { image, wrapper } = getActiveSlideElements();
      if (!image || !wrapper) return;
      const availableX = Math.max(0, (image.clientWidth * currentScale - wrapper.clientWidth) / 2);
      const availableY = Math.max(0, (image.clientHeight * currentScale - wrapper.clientHeight) / 2);
      panX = Math.min(Math.max(panX, -availableX), availableX);
      panY = Math.min(Math.max(panY, -availableY), availableY);
    }

    function getActiveSlideElements() {
      const wrapper = track.querySelectorAll('.ProductModalGallery__imageWrapper')[currentIndex];
      const image = track.querySelectorAll('.ProductModalGallery__image')[currentIndex];
      return { image, wrapper };
    }

    function updateImageTransform() {
      const { image } = getActiveSlideElements();
      if (image) {
        image.style.transform = `translate(${panX}px, ${panY}px) scale(${currentScale})`;
      }
    }

    function toggleMenuVisibility(visible) {
      ['Header', 'AnnouncementBar', 'shopify-chat'].forEach((id) => {
        const element = document.getElementById(id);
        if (!element) return;
        if (visible) {
          element.style.removeProperty('display');
        } else {
          element.style.display = 'none';
        }
      });
    }

    function attachZoomHandlers(wrapper, image) {
      wrapper.addEventListener('wheel', (event) => {
        if (event.ctrlKey || event.deltaY === 0) return;
        event.preventDefault();
        const direction = event.deltaY > 0 ? -0.1 : 0.1;
        const nextScale = Math.min(Math.max(currentScale + direction, 1), 3.5);
        applyScale(nextScale);
      });

      wrapper.addEventListener('dblclick', () => {
        resetZoom();
      });

      image.addEventListener('dragstart', (event) => event.preventDefault());
    }

    return { open };
  }
})();
